import React from 'react';
import { pressLogos, pressMentions } from '../data/content';
export function PressStrip({
  tone = 'shell'
}: {
  tone?: 'shell' | 'sand';
}) {
  return <section aria-label="Media over Beauty Bewust" className={`border-y border-line ${tone === 'shell' ? 'bg-shell' : 'bg-sand'}`} data-id="element-219" data-mp="2i07jrd5ssouh">
      <div className="mx-auto flex max-w-content flex-col items-center gap-6 px-6 py-10 lg:flex-row lg:justify-between lg:gap-12 lg:px-10" data-id="element-220" data-mp="290u8qg20zs7n">
        <p className="whitespace-nowrap text-[11px] uppercase tracking-widest text-muted" data-id="element-221" data-mp="2wrzypo1ok0vo">
          Aanbevolen in
        </p>
        <ul className="flex flex-wrap items-center justify-center gap-x-10 gap-y-5 sm:gap-x-14" data-id="element-222" data-mp="2n1esbefrls27">
          {pressLogos.map(logo => <li key={logo.name} data-id="element-223" data-mp="2rzga7w1gflc3">
              <img src={logo.image} alt={logo.name} className={`${logo.height} w-auto opacity-80 mix-blend-multiply`} data-id="element-224" data-mp="2ryndzp04ge87" />
            </li>)}
          {pressMentions.map(name => <li key={name} className="font-display text-lg text-muted/80 sm:text-xl" aria-label={name} data-id="element-225" data-mp="3u5vhzsoiunqu">
              {name}
            </li>)}
        </ul>
      </div>
    </section>;
}